import React, { useContext } from 'react'
import RightContent from 'modules/react/signup/RightContent'
import LeftContent from 'modules/react/signup/LeftContent'
import SignupContext from 'modules/react/signup/SignupContext'
import WhenStep from 'modules/react/signup/conditionals/WhenStep'
import CourseDateSelection from 'modules/react/signup/CourseDateSelection'
import FormElementError from 'modules/react/signup/FormElementError'
import CourseSummary from 'modules/react/signup/CourseSummary'

import InputMask from 'react-input-mask'
import SignupCompleted from './SignupCompleted'
import NewsletterCheckbox from 'modules/react/signup/NewsletterCheckbox'

export default function SignupContent ({ withBackButton = false }) {

  const signupContext = useContext(SignupContext)

  const { goToNextStep, goBack,restUrls, submit, setFormValue, setEnterCallback } = signupContext


  const completeSignup = () => {
    submit(restUrls.course_plus.signup)
      .then((response) => {
        goToNextStep()
      })
  }

  React.useEffect(() => {
      setEnterCallback(() => completeSignup)
    }, []
  )

  return (
    <>
      <WhenStep is={1}>
        <LeftContent>
          <div className="title title--h3">Udfyld dine oplysninger</div>
          <CourseDateSelection/>
          <div className="title title--h6">Udfyld oplysninger</div>
          <div className="input-group">
            <div className="input-group__half">
              <div className="input-wrap">
                <FormElementError name="firstName">
                  <input type="text" placeholder="Fornavn" onChange={(e) => setFormValue('firstName', e.target.value)}/>
                </FormElementError>
              </div>
              <div className="input-wrap">
                <FormElementError name="lastName">
                  <input type="text" placeholder="Efternavn" onChange={(e) => setFormValue('lastName', e.target.value)}/>
                </FormElementError>
              </div>
            </div>
            <div className="input-wrap">
              <FormElementError name="cpr">
                <InputMask
                  type="text" placeholder="CPR-nr" onChange={(e) => setFormValue('cpr', e.target.value)}
                  mask="999999-9999" disableunderline maskChar={null}
                />
              </FormElementError>
            </div>
            <div className="input-group__half">
              <div className="input-wrap">
                <FormElementError name="phone">
                  <input type="text" placeholder="Telefonnr" onChange={(e) => setFormValue('phone', e.target.value)}/>
                </FormElementError>
              </div>
              <div className="input-wrap">
                <FormElementError name="email">
                  <input type="text" placeholder="Email" onChange={(e) => setFormValue('email', e.target.value.trim())}/>
                </FormElementError>
              </div>
            </div>
          </div>
          <NewsletterCheckbox/>
          <div className="button-section button-section--modal-group">
            {withBackButton && (
              <button className="inline-button inline-button--prim inline-button--back"
                      onClick={goBack}>Tilbage</button>
            )}
            <button className="button button--next" onClick={completeSignup}>
              Tilmeld mig
            </button>
          </div>
        </LeftContent>
        <RightContent>
          <CourseSummary paymentType='Egenbetaling'/>
        </RightContent>
      </WhenStep>

      <WhenStep is={2}>
        <SignupCompleted/>
      </WhenStep>
    </>
  )
}